var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"XVfilter"},[_c('fieldset',[_vm._t("content"),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"XVSearchbar"},[_c('div',{staticClass:"XVSearchbarButtongroup btn-group"},[_vm._t("filterbuttons")],2)])])])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }